<template>
  <div>
    <el-card style="width: 100%">
      <template #header>
        <div class="card-header">
          <span style="font-weight: bold">离职补偿金预估(免费测算)</span>
        </div>
      </template>
      <el-form :model="form" label-width="auto" style="max-width: 450px">

        <el-form-item label="所在地区：">
          <el-cascader
              :placeholder="'请选择所在地区'"
              :options="pcaTextArr"
              v-model="form.userAddress">
          </el-cascader>
        </el-form-item>

        <el-form-item label="离职原因：">
          <el-checkbox v-model="checked.checked1" label="未签合同" />
          <el-checkbox v-model="checked.checked2" label="未缴纳社保" />
          <el-checkbox v-model="checked.checked3" label="欠薪，既成事实降薪" />
          <el-checkbox v-model="checked.checked4" label="不提供劳动条件" />
          <el-checkbox v-model="checked.checked5" label="被书面解除劳动合同（违法）" />
          <el-checkbox v-model="checked.checked6" label="合同到期不续签" />
          <el-checkbox v-model="checked.checked7" label="三期女职工" />
          <el-checkbox v-model="checked.checked8" label="被迫离职" />
        </el-form-item>

        <el-form-item label="该公司工作时长：">
            <div style="display: flex;flex-direction: column;line-height: 40px">
              <div>
                <el-input
                    v-model="form.year"
                    style="max-width: 200px"
                    placeholder="请输入工作年数"
                >
                  <template #append>年</template>
                </el-input>
              </div>
              <div>
                <el-input
                    v-model="form.month"
                    style="max-width: 200px;"
                    placeholder="请输入工作月数"
                >
                  <template #append>月</template>
                </el-input>
              </div>
            </div>
        </el-form-item>

        <el-form-item label="月平均收入：">
          <el-input @input="handleInput"  v-model="form.wages" style="width: 240px" placeholder="请输入月平均薪酬"/>
          <div style="color: #c0c4cc">过去十二个月在当前公司所获薪酬总额的月平均值</div>
        </el-form-item>

        <div v-if="form.money">
          <div style="display: flex;justify-content: center;color: red">可领取金额：<span>{{form.money}}</span></div>
        </div>


        <el-form-item>
          <el-button type="primary" @click="onSubmit">计算</el-button>
          <el-button @click="onReset">重置</el-button>
        </el-form-item>

<!--        <el-tag size="large" type="success">粉丝灯牌连线</el-tag>-->
<!--        <div style="font-size: 32px">粉丝灯牌连线</div>-->
<!--        <div style="display: flex;flex-direction: column">-->
<!--         <div>-->
<!--           <el-text style="font-size: 32px" class="mx-1" type="primary">粉丝灯牌连线</el-text>-->
<!--         </div>-->
<!--         <div>-->
<!--          <el-text style="font-size: 32px" class="mx-1" type="primary">墨镜 插队</el-text>-->
<!--         </div>-->
<!--        </div>-->
      </el-form>

    </el-card>
  </div>
</template>
<script setup lang="ts">
import { reactive, ref } from 'vue';
import {pcaTextArr} from "element-china-area-data";
import {ElButton, ElMessage} from "element-plus";

const form = reactive({
  userAddress: '',
  year: '',
  month: '',
  wages: '',
  reason: '',
  money: '',
})

const checked = reactive({
  checked1: false,
  checked2: false,
  checked3: false,
  checked4: false,
  checked5: false,
  checked6: false,
  checked7: false,
  checked8: false,
})

const onSubmit = () => {
  if (!form.userAddress){
    ElMessage({
      message: '请选择所在地区',
      type: 'error',
    })
    return;
  }
  if (!form.year && !form.month) {
    ElMessage({
      message: '请填写工作年限',
      type: 'error',
    })
    return;
  }
  if (!form.wages) {
    ElMessage({
      message: '请填写月平均薪酬',
      type: 'error',
    })
    return;
  }
  if (!checked.checked1 && !checked.checked2 && !checked.checked3 && !checked.checked4 && !checked.checked5 && !checked.checked6 && !checked.checked7 && !checked.checked8){
    ElMessage({
      message: '请选择离职原因',
      type: 'error',
    })
    return;
  }
  if (!Number.isInteger(Number(form.year)) || form.year < 0){
    ElMessage({
      message: '请填写正确工作年数',
      type: 'error',
    })
    return;
  }
  if (!Number.isInteger(Number(form.month)) || form.month >= 12 || form.month < 0){
    ElMessage({
      message: '请填写正确工作月数',
      type: 'error',
    })
    return;
  }

  //补偿金 = a * b
  //a
  let a = form.wages;
  //b
  let date = Number(form.year) * 12 + Number(form.month);
  console.log('date', date)
  let b = 0;
  switch (true){
    case date < 6:
      b = 0.5;
      break;
    case 6 <= date && date < 12:
      b = 1;
      break;
    case 12 <= date && date < 18:
      b = 1.5;
      break;
    case 18 <= date && date < 24:
      b = 2;
      break;
    case 24 <= date && date < 30:
      b = 2.5;
      break;
    case 30 <= date && date < 36:
      b = 3;
      break;
    case 36 <= date && date < 42:
      b = 3.5;
      break;
    case 42 <= date && date < 48:
      b = 4;
      break;
    case 48 <= date && date < 54:
      b = 4.5;
      break
    case 54 <= date && date < 60:
      b = 5;
      break;
    case 60 <= date && date < 66:
      b = 5.5;
      break;
    case 66 <= date && date < 72:
      b = 6;
      break;
    case 72 <= date && date < 78:
      b = 6.5;
      break;
    case 78 <= date && date < 84:
      b = 7;
      break;
    case 84 <= date && date < 90:
      b = 7.5;
      break;
    case 90 <= date && date < 96:
      b = 8;
      break;
    case 96 <= date && date <102:
      b = 8.5;
      break;
    case 102 <= date && date <108:
      b = 9;
      break;
    case 108 <= date && date <114:
      b = 9.5;
      break;
    case 114 <= date && date <120:
      b = 10;
      break;
    case 120 <= date && date <126:
      b = 10.5;
      break;
    case 126 <= date && date <132:
      b = 11;
      break;
    case 132 <= date && date <138:
      b = 11.5;
      break;
    case 138 <= date:
      b = 12;
      break;
    default:

      break;
  }

  console.log('a', a);
  console.log('b', b);

  console.log('补偿金', a * b);
  if (checked.checked1) {
    let cappedDate = date >= 11 ? 11 : date;
    if (checked.checked5 || checked.checked7) {
      form.money = parseFloat((a * b * 2 + cappedDate * a).toFixed(2));
    } else {
      form.money = parseFloat((a * b + cappedDate * a).toFixed(2));
    }
    return;
  }

  if (checked.checked5 || checked.checked7) {
    form.money = parseFloat((a * b * 2).toFixed(2));
  } else {
    form.money = parseFloat((a * b).toFixed(2));
  }

}


const onReset = () => {
  form.userAddress = '';
  form.year = '';
  form.month = '';
  form.wages = '';
  form.money = '';
  checked.checked1 = false;
  checked.checked2 = false;
  checked.checked3 = false;
  checked.checked4 = false;
  checked.checked5 = false;
  checked.checked6 = false;
  checked.checked7 = false;
  checked.checked8 = false;
}
</script>

<style scoped>

.page {
  background-color: rgb(190,192,192);
}
</style>